export default Object.freeze({
  None: 1,
  AI: 2,
  Agent: 3,
});
